import * as React from 'react';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { EnterpriseDocStoreService } from "../../../common";
import { getInputMaxLengthBasedOnQuestion, getNavigationMultipleButtonProps, getOcrPreviewErrorMessage, getScreenTitleText, shouldEnableOCR } from '../../utilities';
import { IntelligentPhotoCaptureViewType } from '../../enums';
import { IntelligentPhotoCapturePhotoPreviewConstants, PhotoCaptureConstants } from '../../constants';
import { StyledPreviewInput, StyledPhotoPreviewContainer, StyledPreviewMessageContainer, StyledFirstText } from './IntelligentPhotoCapturePhotoPreviewPage.style';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
import { IntelligentPhotoCaptureImageSection } from './IntelligentPhotoCaptureImageSection';
export const IntelligentPhotoCapturePhotoPreview = ({ onRetakePhoto, appTheme, questionSubType, sequenceScreenName, translateFn, shouldAllowMitchellIntelligent, shouldEnableOCRImageTextDecode, isLoading, onViewChange, onSaveManualInterventionData, shouldEnableImageQualityAssessment, countryCode, files, ocrInfo, shouldDisplayIQAScreen, onLoadImageAnalysis, updatePageAttachmentHistory }) => {
    const [updatedOCR, setUpdatedOCR] = React.useState(ocrInfo.ocrText);
    const [errorMessage, setErrorMessage] = React.useState(ocrInfo.errorMessage);
    const isOCREnabledScreens = shouldEnableOCR(questionSubType);
    const isOCREnabled = shouldAllowMitchellIntelligent && shouldEnableOCRImageTextDecode && isOCREnabledScreens;
    const handleHistoryInfo = () => {
        if (isOCREnabled && ocrInfo.isOCRServiceCallCompleted && files && files[0] && files[0].docUID) {
            setUpdatedOCR(ocrInfo.ocrText);
            setErrorMessage(ocrInfo.errorMessage);
            const ocrDetails = { ocrText: ocrInfo.ocrText };
            updatePageAttachmentHistory(files[0].docUID, ocrDetails);
        }
    };
    React.useEffect(() => {
        handleHistoryInfo();
    }, [ocrInfo.isOCRServiceCallCompleted]);
    const handleTextAreaChange = (event) => {
        const inputValue = event.target.value;
        setUpdatedOCR(inputValue);
        setErrorMessage(EMPTY_TEXT);
    };
    const handleNextClickButton = () => {
        const validationErrorMessage = getOcrPreviewErrorMessage(questionSubType, updatedOCR, countryCode);
        if (shouldEnableOCRImageTextDecode && validationErrorMessage) {
            setErrorMessage(validationErrorMessage);
        }
        else {
            if (isOCREnabled && files && files[0] && files[0].docUID) {
                const ocrDetails = { ocrTextFinal: updatedOCR };
                updatePageAttachmentHistory(files[0].docUID, ocrDetails);
            }
            if (shouldEnableImageQualityAssessment && !isOCREnabledScreens) {
                const imageDocUID = files && files[0].docUID;
                onLoadImageAnalysis && onLoadImageAnalysis(imageDocUID, shouldDisplayIQAScreen);
                if (shouldDisplayIQAScreen) {
                    onViewChange(IntelligentPhotoCaptureViewType.IMAGE_IQA, sequenceScreenName);
                }
            }
            else {
                onViewChange(IntelligentPhotoCaptureViewType.COMMENT, sequenceScreenName);
            }
            onSaveManualInterventionData(updatedOCR);
        }
    };
    const multipleButtonProps = Object.assign(Object.assign({}, getNavigationMultipleButtonProps({
        appTheme: Object.assign(Object.assign({}, appTheme), { selectedButtonBackgroundColor: appTheme.buttonBackgroundColor }),
        onLeftClick: () => onRetakePhoto(sequenceScreenName),
        onRightClick: () => handleNextClickButton()
    })), { rightButtonLabel: PhotoCaptureConstants.NEXT, shouldNextButtonDisabled: (isOCREnabled && (isLoading || !updatedOCR)) || false });
    const translatedTitle = translateFn(`${getScreenTitleText(questionSubType, sequenceScreenName)}`);
    return (React.createElement(StyledPhotoPreviewContainer, null,
        React.createElement(IntelligentPBEContainerComponent, { islanguageHide: true, appTheme: appTheme, isFooter: false, hasMultipleButton: true, movePrevious: () => onViewChange(IntelligentPhotoCaptureViewType.NONE, sequenceScreenName), multipleButtonProps: multipleButtonProps, btnIcon: PhotoCaptureConstants.ICON_CLASS, shouldShowAvatar: false, shouldAllowMitchellIntelligent: shouldAllowMitchellIntelligent, warningMessage: translateFn(errorMessage) },
            React.createElement(StyledPreviewMessageContainer, { container: true, direction: "column", alignItems: "center" },
                React.createElement(StyledFirstText, null, translatedTitle)),
            React.createElement(IntelligentPhotoCaptureImageSection, { imageSrc: EnterpriseDocStoreService.createFileUrl((files && files.length && files[0].thumbnail && files[0].thumbnail.docUID) || EMPTY_TEXT) }),
            isOCREnabled && (React.createElement(StyledPreviewInput, { value: isLoading ? translateFn(IntelligentPhotoCapturePhotoPreviewConstants.OCR_PROCESSING_TEXT) : updatedOCR, onChange: handleTextAreaChange, minLength: 0, maxLength: getInputMaxLengthBasedOnQuestion(questionSubType), placeholder: `${translateFn(`${IntelligentPhotoCapturePhotoPreviewConstants.REVIEW_PLACEHOLDER_TEXT} ${getScreenTitleText(questionSubType, sequenceScreenName).toLowerCase()}`)}...` })))));
};
//# sourceMappingURL=IntelligentPhotoCapturePhotoPreview.js.map